import { render } from "./Autobet.vue?vue&type=template&id=17f55c25&scoped=true"
import script from "./Autobet.vue?vue&type=script&lang=js"
export * from "./Autobet.vue?vue&type=script&lang=js"

import "./Autobet.vue?vue&type=style&index=0&id=17f55c25&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f55c25"]])

export default __exports__